/* eslint-disable */
import {ProductListType} from './ProductListType';
import {FacetFilter} from './FacetFilter';
import {ProductlistViewProduct} from './ProductlistViewProduct';
import {SortOrder} from './SortOrder';
import {ApptusPageModel} from './ApptusPageModel';
import {ReactComponent} from './ReactComponent';
import {INotifyLink} from './INotifyLink';
import {SuggestedThecaProduct} from './SuggestedThecaProduct';
import {IMenuItem} from './IMenuItem';
import {ProductlistPageBrandContent} from './ProductlistPageBrandContent';
import {SliderAd} from './SliderAd';
import {RedAd} from './RedAd';
import {CountdownAd} from './CountdownAd';
import {LeaderBoardAd} from './LeaderBoardAd';
export interface IProductList {
	productlistType: ProductListType;
	filterPanels: FacetFilter[];
	products: ProductlistViewProduct[];
	pageNbr: number;
	nbrOfHits: number;
	totalNbrOfHits: number;
	productsPerPage: number;
	nbrOfPages: number;
	sortOrders: SortOrder[];
	selectedSortOrder: SortOrder;
}
export enum SearchSource {
	Search = 0,
	Theca = 1,
	
}
/**
* @description Interface for Avensia.Commerce.Web.Models.Pages.ProductlistBase
*/
export interface ProductlistBase extends ApptusPageModel {
	productlistType: ProductListType;
	filterPanels: FacetFilter[];
	products: ProductlistViewProduct[];
	isCategoryFilterPage: boolean;
	pageNbr: number;
	nbrOfHits: number;
	totalNbrOfHits: number;
	productsPerPage: number;
	nbrOfPages: number;
	sortOrders: SortOrder[];
	selectedSortOrder: SortOrder;
	siteModeSpecificClearAttributes: string[];
	/**
    * @version - Property is marked as versioned and might not exist for usage
    **/
    orderedFilterAttributes?: string[];
}
/**
* @description Interface for Avensia.Commerce.Web.Models.Pages.SearchProductlistPageModel
*/
export interface SearchProductlistPageModel extends ProductlistBase {
	isCategoryFilterPage: boolean;
	header: ReactComponent;
	subHeader?: ReactComponent;
	suggestedCategories?: INotifyLink[];
	relatedSearchPhrases?: string[];
	failedSearchPhrase?: string;
	suggestedSearchPhrase?: string;
	externalProductsResult?: SuggestedThecaProduct[];
	source: SearchSource;
}
export const isSearchProductlistPage = (model: unknown): model is SearchProductlistPageModel => (model as SearchProductlistPageModel).componentName === 'SearchProductlistPage';
/**
* @description Interface for Avensia.Commerce.Web.Models.Pages.ProductlistPageModel
*/
export interface ProductlistPageModel extends ProductlistBase {
	productlistType: ProductListType;
	isCategoryFilterPage: boolean;
	categoryFilterFacet: string;
	categoryFilterName: string;
	rootCategory: IMenuItem;
	header: string;
	brandContent?: ProductlistPageBrandContent;
	sliderAds: SliderAd[];
	/**
    * @version - Property is marked as versioned and might not exist for usage
    **/
    currentCampaignAds?: RedAd[];
	description: string;
	seoBlock: ReactComponent;
	countdownAd?: CountdownAd;
	leaderboardInProductList?: LeaderBoardAd;
	/**
    * @version - Property is marked as versioned and might not exist for usage
    **/
    categoryNavigationItems?: IMenuItem[];
	/**
    * @version - Property is marked as versioned and might not exist for usage
    **/
    filterCategories?: IMenuItem[];
	content: ReactComponent[];
}
export const isProductlistPage = (model: unknown): model is ProductlistPageModel => (model as ProductlistPageModel).componentName === 'ProductlistPage';
